import { CommonModule } from '@angular/common';
import { Component, computed, effect, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { matStar, matStarBorder } from '@ng-icons/material-icons/baseline';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicField } from '@shared/components/dynamic-form/models/field';
import { StarRatingSettings } from '@shared/components/dynamic-form/models/field-star-rating';

@Component({
  selector: 'app-star-rating-field',
  imports: [CommonModule, NgIcon, ReactiveFormsModule, TranslateModule],
  viewProviders: [provideIcons({ matStar, matStarBorder })],
  templateUrl: './star-rating-field.component.html',
})
export class StarRatingFieldComponent {
  field = input.required<DynamicField>();
  form = input.required<FormGroup>();

  hoveredRating = 0;
  selectedRating = 0;

  stars = computed(() => {
    return new Array(
      +((this.field()?.settings as StarRatingSettings)?.stars || 2)
    )
      .fill(0)
      .map((_, i) => i + 1);
  });

  get formControl() {
    return this.form()?.controls[this.field().key];
  }

  constructor() {
    effect(() => {
      const value = this.formControl?.value;
      if (value) {
        this.selectedRating = +value;
      }
    });
  }

  onStarHover(rating: number) {
    this.hoveredRating = rating;
  }

  onStarLeave() {
    this.hoveredRating = 0;
  }

  onStarClick(rating: number) {
    this.selectedRating = rating;
    this.formControl?.setValue(rating);
  }

  isStarActive(star: number): boolean {
    return (
      star <=
      (this.hoveredRating ||
        this.selectedRating ||
        this.formControl?.value ||
        0)
    );
  }
}
